import { useSearchParams } from "react-router";

import { VoltSubpageHeader } from "../ui/VoltSubpageHeader";
import { useWorkshopAccess } from "../workshop/useWorkshopAccess";
import { listLink } from "./fundingLinks";
import { FundingDenied, FundingLoading } from "./FundingStates";
import { FundingScale } from "./FundingScale";
import { NO_ACCESS, useFundingScale } from "./useFundingList";

/** The page behind the info button: how our ranking comes about. */
export const FundingRankingPage = () => {
  const access = useWorkshopAccess();
  const [params] = useSearchParams();
  const scale = useFundingScale(access === "granted");
  if (access === "denied") return <FundingDenied reason={NO_ACCESS} />;
  return (
    <div className="flex flex-col gap-5">
      <VoltSubpageHeader
        back={{
          to: listLink("/funding-list", params),
          label: "Zurück zur Liste",
        }}
        title="So entsteht unser Ranking"
      />
      {scale ? <FundingScale scale={scale} /> : <FundingLoading />}
    </div>
  );
};
